<template>
  <div>
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="地址标记" name="address"></el-tab-pane>
      <el-tab-pane label="手机号标记" name="phone"></el-tab-pane>
    </el-tabs>
    <address-list ref="addressList" v-if="tabName=='address'" />
    <phone-list ref="phoneList" v-if="tabName=='phone'" />
  </div>
</template>
<script>
import addressList from './addressList'
import phoneList from './phoneList'

export default {
  components: {
    addressList,
    phoneList,
  },
  data() {
    return {
      tabName: "address"
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$refs[this.tabName + "List"].getData()
    },
    handleClick() {
      this.$nextTick(() => {
        this.getData()
      })
    }
  }
}
</script>